












































import { Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import Vue from '@/vue.type';
import UserAvatarComponent from '@/shared/avatars/user/user-avatar.component.vue';
import UsertAvatar from '@/shared/avatars/user/user-avatar.class';
import snackBarService from '@/shared/snackbar/snackbar.service';
import ProjectWithMembers from '@/domain/project/project-with-members.entity';
import AuthorityStore from '@/domain/security/authority.store';
import Authority from '@/domain/security/authority.entity';

@Component({
  components: {
    UserAvatarComponent,
  },
})
export default class HomeRecentProjectsComponent extends Vue {
  @Prop({
    required: false,
    default: [],
  })
  private projects?: ProjectWithMembers[];

  @Prop({
    required: false,
    default: [],
  })
  private icons?: any[];

  private navigate(name: string, path: string): void {
    if (name) {
      this.$router.push(`/${name}/${path}`);
    }
  }

  private authorities: Authority = new Authority([]);

  created() {
    this.checkAutorities();
  }

  private clickIcon(project: ProjectWithMembers, icon: any): void {
    if (icon.path) this.navigate(project.name, icon.path);
    if (icon.title === 'editProject') this.$emit('openEditProjectModal', project);
    if (icon.title === 'dashboard.report') {
      if (process.env.VUE_APP_REPORT_DASHBOARD_URL) {
        const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
        const endOfMonth = moment().endOf('month').format('YYYY-MM-DD');
        const url = `${process.env.VUE_APP_REPORT_DASHBOARD_URL}&%24project=${project.id.replace(/-/g, '').toUpperCase()}&%24dtStart=${startOfMonth}&%24dtFinish=${endOfMonth}`;
        this.$router.push({ path: '/mandala-report', query: { reportUrl: url } });
      } else {
        snackBarService.errorMessage('Relatório ainda não definido para o Dashboard.');
      }
    }
  }

  private checkAutorities() {
    AuthorityStore.fetchedAuthority()
      .then((resp: Authority) => this.authorities = resp);
  }

  get getFilteredIcons(): string[] {
    return this.icons!!.filter((el: any) => {
      if (el.authorities.length > 0) {
        return this.authorities.hasAuthorities(el.authorities);
      }
      return true;
    });
  }
}
